<template>
    <div>
        <div v-if="current_user.permissions.length > 0" id="open-banking-requests-list" :class="['tab-pane', tab == 'open-banking-requests-list' ? 'active' : '']">
          <open-banking-requests-filter :action="filterAction" form_id=""></open-banking-requests-filter>
          <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
    </div>
</template>

<script>
import requestsColumns from './datatable/requests-columns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import $ from "jquery";
import openBankingRequestsFilter from '@/views/openBanking/components/common-access/requests-filter.vue'

export default {

    components: {
        'open-banking-requests-filter': openBankingRequestsFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "ivr_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('open-banking/requests/common/get'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: requestsColumns,
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#application_checkbox')

            if (checkbox.is(":checked"))
                this.query.my_requests = 1
            else
                this.query.my_requests = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>